import(/* webpackMode: "eager", webpackExports: ["CartWraper"] */ "/home/ec2-user/website/salontymwebweb/app/components/cart/cart/CartWraper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/footer/Footer.tsx");
